interface Config {
  TRIPS_URL: string;
  PARTNERS_URL: string;
  Z3_URL: string;
  GOOGLE_CLIENT_ID: string;
  PUSHER_APP_KEY: string;
  PUSHER_APP_CLUSTER: string;
  HOTJAR_SITE_ID?: number;
  HOTJAR_VERSION?: number;
  GTM_ID: string;
  CHATWAY_WIDGET_ID: string;
  RUM_APP_MONITOR_ID: string;
  RUM_IDENTITY_POOL_ID: string;
  RUM_ENVIRONMENT: 'dev' | 'prod';
}

const local: Config = {
  TRIPS_URL: 'http://localhost:3000/',
  PARTNERS_URL: '#', // cannot provide a value for this
  Z3_URL: 'http://localhost:8000/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  GTM_ID: '',
  CHATWAY_WIDGET_ID: 'XGM9j6hxXlU5',
  RUM_APP_MONITOR_ID: '7aa4c6de-6131-411c-a00f-28b18a5cd023',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const dev: Config = {
  TRIPS_URL: 'http://localhost:3000/',
  PARTNERS_URL: '#', // cannot provide a value for this
  Z3_URL: 'https://www-qa.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  GTM_ID: '',
  CHATWAY_WIDGET_ID: 'XGM9j6hxXlU5',
  RUM_APP_MONITOR_ID: '7aa4c6de-6131-411c-a00f-28b18a5cd023',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const staging: Config = {
  TRIPS_URL: 'https://trips-staging.zicasso.com/',
  PARTNERS_URL: 'https://partners-staging.zicasso.com/',
  Z3_URL: 'https://www-staging.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  HOTJAR_SITE_ID: 881764,
  HOTJAR_VERSION: 6,
  GTM_ID: 'GTM-MX6B98ZJ',
  CHATWAY_WIDGET_ID: 'XGM9j6hxXlU5',
  RUM_APP_MONITOR_ID: '7aa4c6de-6131-411c-a00f-28b18a5cd023',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const prod: Config = {
  TRIPS_URL: 'https://trips.zicasso.com/',
  PARTNERS_URL: 'https://partners.zicasso.com/',
  Z3_URL: 'https://www.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '88f77513b2a5e074a7e5',
  PUSHER_APP_CLUSTER: 'us3',
  HOTJAR_SITE_ID: 930825,
  HOTJAR_VERSION: 6,
  GTM_ID: 'GTM-W8SF6SJL',
  CHATWAY_WIDGET_ID: 'XGM9j6hxXlU5',
  RUM_APP_MONITOR_ID: 'e2cf8e6d-7c73-4cd0-9543-c126fa71694d',
  RUM_IDENTITY_POOL_ID: 'us-west-2:e4b128d9-b7e0-461f-9919-828e7fe173e2',
  RUM_ENVIRONMENT: 'prod',
};

const qa: Config = {
  TRIPS_URL: 'https://trips-qa.zicasso.com/',
  PARTNERS_URL: 'https://partners-qa.zicasso.com/',
  Z3_URL: 'https://www-qa.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  GTM_ID: 'GTM-5J5GSXHV',
  CHATWAY_WIDGET_ID: 'XGM9j6hxXlU5',
  RUM_APP_MONITOR_ID: '7aa4c6de-6131-411c-a00f-28b18a5cd023',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

// eslint-disable-next-line import/no-mutable-exports
let config: Config;
if (process.env.REACT_APP_STAGE === 'prod') {
  config = { ...prod };
} else if (process.env.REACT_APP_STAGE === 'staging') {
  config = { ...staging };
} else if (process.env.REACT_APP_STAGE === 'local') {
  config = { ...local };
} else if (process.env.REACT_APP_STAGE === 'qa') {
  config = { ...qa };
} else {
  config = { ...dev };
}

export default config;
